import { NAME_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validateName = (name: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = NAME_VALIDATOR.test(String(name));
  if (!isValid) {
    result.error = 'Invalid name';
    result.isValid = false;
  }

  return result;
};
